import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import dashboard from './dashboard/reducers'
import allUsers from './allUsers/reducers'
import refunds from './refunds/reducers'
import utility from './utility/reducers'
import agentDashboard from './agentDashboard/reducers'
import transaction from './transaction/reducers'
import business from './business/reducers'
import subscriptions from './subscriptions/reducers'
import customer from './customer/reducers'
import walletLedger from './walletledger/reducer'
import payments from './payments/reducers'
import peyme from './peyme/reducers'
import invoices from './invoices/reducers'
import checkouts from './checkouts/reducers'
import downloadsReducer from './downloads/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    agentDashboard,
    transaction,
    menu,
    settings,
    dashboard,
    allUsers,
    refunds,
    utility,
    business,
    subscriptions,
    customer,
    walletLedger,
    payments,
    peyme,
    invoices,
    checkouts,
    downloadsReducer,
  })
